import { Injectable } from "@angular/core";
import { EMPTY, catchError, from, map, mergeMap, of } from "rxjs";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as reportsActions from "./reports.actions";
import * as errorActions from "../../core/error/ngrx/error.actions";
import { DataService } from "src/app/supabase/services/data.service";

@Injectable()
export class ReportEffects {
  constructor(private actions$: Actions, private dataService: DataService) {}

  loadReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reportsActions.loadReports),
      mergeMap(() =>
        from(this.dataService.getReports()).pipe(
          map((reports) => reportsActions.loadReportsSuccess({ reports })),
          catchError((error) => of(errorActions.handleError({error: "Die Berichte konnten nicht geladen werden.", showToast: false, exception: error})))
        )
      )
    )
  );

  deleteReport$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reportsActions.deleteReport),
      mergeMap((body) =>
        from(this.dataService.deleteReport(body.report)).pipe(
          map((report_generator_id) =>
            reportsActions.deleteReportSuccess({ report_generator_id })
          ),
          catchError((error) => of(errorActions.handleError({error: "Der Bericht konnte nicht gelöscht werden.", exception: error})))
        )
      )
    )
  );

  loadReportConfigurations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(reportsActions.loadReportConfigurations),
      mergeMap(() =>
        from(this.dataService.getReportConfigurations()).pipe(
          map((reportConfigurations) =>
            reportsActions.loadReportConfigurationsSuccess({ reportConfigurations })
          ),
          catchError((error) => of(errorActions.handleError({error: "Die Berichtskonfigurationen konnten nicht geladen werden.", showToast: false, exception: error})))
        )
      )
    )
  )
}
